import classNames from 'classnames';
import React from 'react';
import { CSVLink } from 'react-csv';

function CSVDownloader({ data, filename, className }) {
  return (
    <CSVLink data={data} filename={`${filename}.csv`} key={data}>
      <i
        className={classNames(
          'fas fa-download fa-2x cursor-pointer text-white',
          className,
        )}
      />
    </CSVLink>
  );
}

export default CSVDownloader;
